<template>
  <div>
    <div class="right_menu">
      <div>404 正在开发中,敬请期待...!</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TrainModel',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.right_menu {
  width: calc(100vw - 360px);
  height: calc(100vh - 80px);
  padding: 0 100px;
  overflow-y: scroll;
  overflow-x: hidden;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  div {
    font-size: 50px;
    font-weight: bold;
    color: @font_gray;
    text-align: center;
    line-height: calc(100vh - 80px);

  }
}
</style>
<style>
@import "@/assets/fonts/style.css"
</style>
